import { defineAction } from '~/prix'
import { z } from 'zod'
import creditBracketCreateAction from './creditBracketCreate.action.json' with { type: 'json' }
import { creditBracketCreateInputObject, creditBracketObject } from '../creditBracketObject'

const creditBracketCreateDefinition = defineAction({
  ...creditBracketCreateAction,

  input: creditBracketCreateInputObject,
  output: z.object({ id: creditBracketObject.shape.id }),
})

export default creditBracketCreateDefinition

